import React, { useState } from "react";
import AssignPermTable from "../../../components/backoffice/accessPermission/AssignPermTable";
import { minus, plusIcon } from "../../../assetData/icons";

const ConfigTable = ({
  tableData,
  setSelectedItemId,
  buttonConfig,
  edited,
  setEdited,
  filterData,
  setIsDelete,
  isButtonClicked
}) => {
  const [rowId, setRowId] = useState({});

  const [isDropDownVisible, setDropDownVisibility] = useState(false);
  const [rowEdit, setRowEdit] = useState();

  const setRowIdAndHideShow = (info) => {
    setRowId(info);
    setDropDownVisibility((prevVisibility) => !prevVisibility);
  };

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "main_menu_id",
        header: () => <span className="flex justify-center px-1">Menu ID</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-center  px-1">
            {info.getValue()}
          </span>
        ),
      },

      {
        accessorKey: "main_menu",
        header: () => (
          <span className=" w-[300px] px-1">Main Menu/Sub Menu</span>
        ),
        cell: (info) => (
          <span
            onClick={() => setRowIdAndHideShow(info)}
            className="z-10 flex h-[24px] w-full items-center justify-start px-1 opacity-0"
          >
            <img
              src={isDropDownVisible ? minus : plusIcon}
              alt=""
              className="cursor-pointer hover:scale-[1.5]"
            />{" "}
            {info.getValue()}
          </span>
        ),
      },

      {
        accessorKey: "sub_menu_id",
        header: () => (
          <span className="flex justify-center px-1">Sub-Menu ID</span>
        ),
        cell: (info) => (
          <span className=" flex h-[24px] justify-center px-1 opacity-0">
            {info.getValue()}
          </span>
        ),
      },

      {
        accessorKey: "sort_order",
        header: () => (
          <span className="flex justify-center px-1">Sort Order</span>
        ),
        cell: (info) => (
          <span className=" flex h-[24px] justify-center px-1 opacity-0">
            {info.getValue()}
          </span>
        ),
      },

      {
        accessorKey: "add_perm",
        header: () => <span className="flex justify-start px-1">Add</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "edit_perm",
        header: () => <span className="flex justify-start px-1">edit</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "view_perm",
        header: () => <span className="flex justify-start px-1">view</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "delete_perm",
        header: () => <span className="flex justify-start px-1">delete</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "download_perm",
        header: () => <span className="flex justify-start px-1">download</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "import_perm",
        header: () => <span className="flex justify-start px-1">import</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "True" : "False"}
          </span>
        ),
      },
      {
        accessorKey: "status",
        header: () => <span className="flex justify-center px-1">Status</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue() ? "Active" : "Inactive"}
          </span>
        ),
      },
      {
        accessorKey: "icons",
        header: () => <span className="flex justify-center px-1">Action</span>,
        cell: (info) => (
          <span className=" flex h-[24px] justify-start px-1 opacity-0">
            {info.getValue()}
          </span>
        ),
      },
    ],
    [ isDropDownVisible],
  );
  return (
    <AssignPermTable
      columns={columns}
      tableData={tableData}
      setSelectedItemId={setSelectedItemId}
      rowId={rowId}
      isDropDownVisible={isDropDownVisible}
      buttonConfig={buttonConfig}
      edited={edited}
      setEdited={setEdited}
      setRowEdit={setRowEdit}
      rowEdit={rowEdit}
      filterData={filterData}
      setIsDelete={setIsDelete}
      isButtonClicked={isButtonClicked}
    />
  );
};

export default ConfigTable;
